"use client"

import { useState } from "react"
import { useNavigate } from "react-router-dom"

// Custom SVG Icons as components
const PencilIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
  </svg>
)

const UploadIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
    <path d="M12,11L16,15H13V19H11V15H8L12,11Z" />
  </svg>
)

const DownloadIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z" />
  </svg>
)

const PaymentIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.11,4 20,4M20,18H4V12H20V18M20,8H4V6H20V8Z" />
  </svg>
)

const BankIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
    <path d="M11.5,1L2,6V8H21V6M16,10V17H19V19H5V17H8V10H10V17H14V10H16Z" />
  </svg>
)

const CreditCardIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.11,4 20,4M20,18H4V12H20V18M20,8H4V6H20V8Z" />
  </svg>
)

const HomeIcon = () => (
  <svg width="20" height="20" left="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z" />
  </svg>
)

const MenuIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z" />
  </svg>
)

const ArrowLeftIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z" />
  </svg>
)

const ShoppingCartIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17,18C15.89,18 15,18.89 15,20A2,2 0 0,0 17,22A2,2 0 0,0 19,20C19,18.89 18.1,18 17,18M1,2V4H3L6.6,11.59L5.24,14.04C5.09,14.32 5,14.65 5,15A2,2 0 0,0 7,17H19V15H7.42A0.25,0.25 0 0,1 7.17,14.75C7.17,14.7 7.18,14.66 7.2,14.63L8.1,13H15.55C16.3,13 16.96,12.58 17.3,11.97L20.88,5H5.21L4.27,3H1M7,18C5.89,18 5,18.89 5,20A2,2 0 0,0 7,22A2,2 0 0,0 9,20C9,18.89 8.1,18 7,18Z" />
  </svg>
)

const LogOutIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M16,17V14H9V10H16V7L21,12L16,17M14,2A2,2 0 0,1 16,4V6H14V4H5V20H14V18H16V20A2,2 0 0,1 14,22H5A2,2 0 0,1 3,20V4A2,2 0 0,1 5,2H14Z" />
  </svg>
)

const ChevronRightIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
  </svg>
)

const Dashboard = () => {
  const [activeMenuItem, setActiveMenuItem] = useState("Home")
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("bank")
  const navigate = useNavigate()

  const menuItems = [
    { name: "Home", icon: HomeIcon, hasSubmenu: true },
    { name: "Online Prayer Requests", icon: PencilIcon, hasSubmenu: true },
    { name: "Upload Prayer Forms", icon: UploadIcon, hasSubmenu: false },
    { name: "Download Prayer Forms", icon: DownloadIcon, hasSubmenu: true },
    { name: "Payments & Offerings", icon: PaymentIcon, hasSubmenu: false },
    { name: "My Basket", icon: ShoppingCartIcon, hasSubmenu: false },
    { name: "Sign Out", icon: LogOutIcon, hasSubmenu: false },
  ]

  const dashboardCards = [
    {
      title: "Online Prayer Requests",
      description: "Browse through prayer forms and make your submission online",
      icon: PencilIcon,
      color: "#7fb3a3",
    },
    {
      title: "Upload Prayer Request Forms",
      description: "You can upload photos of handwritten prayer request forms by selecting this option",
      icon: UploadIcon,
      color: "#7fb3a3",
    },
  ]

  const paymentMethods = [
    {
      id: "card",
      title: "CARD PAYMENT",
      icon: CreditCardIcon,
      available: false,
    },
    {
      id: "bank",
      title: "BANK TRANSFER",
      icon: BankIcon,
      available: true,
    },
  ]

  const styles = {
    container: {
      display: "flex",
      minHeight: "100vh",
      backgroundColor: "#f5f5f5",
      fontFamily: "Arial, sans-serif",
    },
    header: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      height: "80px",
      backgroundColor: "#6b7280",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "0 20px",
      zIndex: 1000,
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    },
    logo: {
      fontSize: "2rem",
      fontFamily: "cursive",
      color: "white",
      fontWeight: "300",
    },
    headerLeft: {
      display: "flex",
      alignItems: "center",
      gap: "20px",
    },
    headerRight: {
      display: "flex",
      alignItems: "center",
      gap: "15px",
    },
    menuButton: {
      background: "none",
      border: "none",
      color: "white",
      fontSize: "1.5rem",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      padding: "8px",
    },
    goBackButton: {
      background: "none",
      border: "none",
      color: "white",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      cursor: "pointer",
      fontSize: "1rem",
      padding: "8px 12px",
    },
    cartIcon: {
      position: "relative",
      color: "white",
      fontSize: "1.5rem",
      cursor: "pointer",
      padding: "8px",
    },
    cartBadge: {
      position: "absolute",
      top: "0px",
      right: "0px",
      backgroundColor: "#ef4444",
      color: "white",
      borderRadius: "50%",
      width: "20px",
      height: "20px",
      fontSize: "0.75rem",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "70px",
    },
    signOutButton: {
      backgroundColor: "#9ca3af",
      color: "white",
      border: "none",
      padding: "8px 16px",
      borderRadius: "4px",
      cursor: "pointer",
      fontSize: "0.9rem",
    },
    sidebar: {
      backgroundColor: "#7fb3a3",
      paddingTop: "80px",
      minHeight: "100vh",
      position: "fixed",
      borderRadius: "30px",
    },
    menuItem: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "15px 20px",
      color: "white",
      cursor: "pointer",
      borderBottom: "1px solid #4b5561",
      fontSize: "0.95rem",
      transition: "background-color 0.2s",
      borderTopLeftRadius: "30px",
      borderBottomLeftRadius: "30px",
      marginBottom: "20px",
    },
    menuItemActive: {
      backgroundColor: "#4b5563",
    },
    menuItemHover: {
      backgroundColor: "#4b5563",
    },
    menuItemLeft: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
    },
    mainContent: {
      marginLeft: "270px",
      paddingTop: "80px",
      flex: 1,
      padding: "100px 40px 40px 310px",
      width: "calc(100% - 270px)",
    },
    breadcrumb: {
      display: "flex",
      alignItems: "left",
      marginLeft: "-200px",
      marginBottom: "30px",
      color: "#6b7280",
      fontSize: "0.9rem",
    },
    cardsGrid: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "100px",
      width: "100%",
      marginBottom: "50px",
    },
    card: {
      backgroundColor: "#7fb3a3",
      borderRadius: "12px",
      padding: "50px 40px",
      textAlign: "center",
      color: "white",
      cursor: "pointer",
      marginLeft: "-200px",
      transition: "transform 0.2s, box-shadow 0.2s, border 0.2s",
      Height: "100px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      border: "3px solid transparent",
    },
    cardIcon: {
      fontSize: "4rem",
      marginBottom: "25px",
      opacity: 0.9,
      display: "flex",
      justifyContent: "center",
    },
    cardTitle: {
      fontSize: "1.5rem",
      fontWeight: "600",
      marginBottom: "15px",
      lineHeight: "1.3",
    },
    cardDescription: {
      fontSize: "1rem",
      opacity: 0.9,
      lineHeight: "1.4",
      maxWidth: "300px",
    },
    paymentSection: {
      marginTop: "50px",
      marginLeft: "-200px",
    },
    paymentTitle: {
      fontSize: "1.8rem",
      fontWeight: "600",
      marginBottom: "30px",
      color: "#374151",
    },
    paymentGrid: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "20px",
      maxWidth: "600px",
    },
    paymentCard: {
      backgroundColor: "white",
      borderRadius: "12px",
      padding: "40px 30px",
      textAlign: "center",
      cursor: "pointer",
      transition: "all 0.3s ease",
      border: "2px solid #e5e7eb",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "250px",
      width: "450px",
    },
    paymentCardUnavailable: {
      backgroundColor: "#9ca3af",
      color: "#6b7280",
      cursor: "not-allowed",
      opacity: 0.6,
    },
    paymentCardAvailable: {
      backgroundColor: "white",
      color: "#374151",
      border: "2px solid #3b82f6",
    },
    paymentCardSelected: {
      backgroundColor: "#eff6ff",
      border: "2px solid #2563eb",
      boxShadow: "0 4px 12px rgba(37, 99, 235, 0.15)",
    },
    paymentIcon: {
      marginBottom: "20px",
      opacity: 0.8,
    },
    paymentCardTitle: {
      fontSize: "1.1rem",
      fontWeight: "600",
      letterSpacing: "0.5px",
    },
    unavailableText: {
      fontSize: "1.2rem",
      fontWeight: "700",
      marginBottom: "10px",
      color: "#6b7280",
    },
  }

  return (
    <div style={styles.container}>
      {/* Header */}
      <header style={styles.header}>
        <div style={styles.headerLeft}>
          <button style={styles.menuButton}>
            <MenuIcon />
          </button>
          <img src="/logo.png" alt="Shinnyo Logo" style={{ height: "70px", objectFit: "contain" }} />
          <button style={styles.goBackButton} onClick={() => window.history.back()}>
            <ArrowLeftIcon />
            Go Back
          </button>
        </div>
        <div style={styles.headerRight}>
          <div style={styles.cartIcon} onClick={() => navigate("/basket")}>
            <ShoppingCartIcon />
            <span style={styles.cartBadge}>0</span>
          </div>
          <button style={styles.signOutButton} onClick={() => navigate("/login")}>
            Sign Out
          </button>
        </div>
      </header>

      {/* Sidebar */}
      <nav style={styles.sidebar}>
        {menuItems.map((item, index) => {
          const IconComponent = item.icon
          return (
            <div
              key={index}
              style={{
                ...styles.menuItem,
                ...(activeMenuItem === item.name ? styles.menuItemActive : {}),
              }}
              onClick={() => {
                setActiveMenuItem(item.name)

                if (item.name === "My Basket") {
                  navigate("/basket")
                }

                if (item.name === "Home") {
                  navigate("/home")
                }

                if (item.name === "Sign Out") {
                  navigate("/login")
                }

                if (item.name === "Online Prayer Requests") {
                  navigate("/#")
                }

                if (item.name === "Upload Prayer Forms") {
                  navigate("/upload-forms")
                }
              }}
              onMouseEnter={(e) => {
                if (activeMenuItem !== item.name) {
                  e.target.style.backgroundColor = "#4b5563"
                }
              }}
              onMouseLeave={(e) => {
                if (activeMenuItem !== item.name) {
                  e.target.style.backgroundColor = "transparent"
                }
              }}
            >
              <div style={styles.menuItemLeft}>
                <IconComponent />
                <span>{item.name}</span>
              </div>
              {item.hasSubmenu && <ChevronRightIcon />}
            </div>
          )
        })}
      </nav>

      {/* Main Content */}
      <main style={styles.mainContent}>
        {/* Breadcrumb */}
        <div style={styles.breadcrumb}>
          <HomeIcon />
          <span>/</span>
          <span style={{ color: "#555", fontSize: "14px" }}>
            Home &gt; Checkout &gt; Payment Types
          </span>

        </div>

        {/* Cards Grid */}
        <div style={styles.cardsGrid}>
          {dashboardCards.map((card, index) => {
            const IconComponent = card.icon
            return (
              <div>

              </div>
            )
          })}
        </div>

        {/* Payment Methods Section */}
        <div style={styles.paymentSection}>
          <div style={styles.paymentGrid}>
            {paymentMethods.map((method) => {
              const IconComponent = method.icon
              const isSelected = selectedPaymentMethod === method.id
              const isAvailable = method.available

              return (
                <div
                  key={method.id}
                  style={{
                    ...styles.paymentCard,
                    ...(isAvailable ? styles.paymentCardAvailable : styles.paymentCardUnavailable),
                    ...(isSelected && isAvailable ? styles.paymentCardSelected : {}),
                  }}
                  onClick={() => {
                    if (isAvailable) {
                      setSelectedPaymentMethod(method.id)

                      // Navigate to basket2 when user selects Bank Transfer
                      if (method.id === "bank") {
                        navigate("/basket2")
                      }
                    }
                  }}
                >
                  {!isAvailable && <div style={styles.unavailableText}>UNAVAILABLE</div>}
                  <div style={styles.paymentIcon}>
                    <IconComponent />
                  </div>
                  <div style={styles.paymentCardTitle}>{method.title}</div>
                </div>
              )
            })}
          </div>
        </div>
      </main>
    </div>
  )
}

export default Dashboard
